import React from "react";
import { makeStyles } from "@mui/styles";
import Header from "components/Header/Header.js";
import HomeFooter from "components/Footer/HomeFooter.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from '../styles/staticPages.js';
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import { useSelector } from "react-redux";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import pageBg from "assets/img/driver2.jpg";

const dashboardRoutes = [];
const useStyles = makeStyles(styles);

export default function ContactUs(props) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const classes = useStyles();
  const { ...rest } = props;
  const settings = useSelector(state => state.settingsdata.settings);

  return (
    <div className={classes.pageRoot}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 80,
          color: "conecta2Light"
        }}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{ backgroundImage: `url(${pageBg})` }}
      >
        <div className={classes.contentWrap}>
          <div
            className={classes.glassCard}
            style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr', textAlign: isRTL === 'rtl' ? 'right' : 'left' }}
          >
            <div className={classes.eyebrow}>HABLA CON NOSOTROS</div>
            <h1 className={classes.title}>
              {t('contact_us')} <span>Conecta2</span>
            </h1>
            <div className={classes.underline} />

            {settings?.CompanyName ? (
              <div className={classes.detailRow}>
                <div className={classes.detailIcon}>
                  <BusinessOutlinedIcon sx={{ fontSize: 22 }} />
                </div>
                <div>
                  <span className={classes.detailLabel}>Empresa</span>
                  <div className={classes.companyName}>{settings.CompanyName}</div>
                </div>
              </div>
            ) : null}

            {settings?.CompanyAddress ? (
              <div className={classes.detailRow}>
                <div className={classes.detailIcon}>
                  <PlaceOutlinedIcon sx={{ fontSize: 22 }} />
                </div>
                <div>
                  <span className={classes.detailLabel}>Dirección</span>
                  <div>{settings.CompanyAddress}</div>
                </div>
              </div>
            ) : null}

            {settings?.contact_email ? (
              <div className={classes.detailRow}>
                <div className={classes.detailIcon}>
                  <EmailOutlinedIcon sx={{ fontSize: 22 }} />
                </div>
                <div>
                  <span className={classes.detailLabel}>{t('email')}</span>
                  <a href={`mailto:${settings.contact_email}`} className={classes.detailLink}>
                    {settings.contact_email}
                  </a>
                </div>
              </div>
            ) : null}

            {settings?.CompanyPhone ? (
              <div className={classes.detailRow}>
                <div className={classes.detailIcon}>
                  <PhoneOutlinedIcon sx={{ fontSize: 22 }} />
                </div>
                <div>
                  <span className={classes.detailLabel}>{t('phone')}</span>
                  <a href={`tel:${settings.CompanyPhone}`} className={classes.detailLink}>
                    {settings.CompanyPhone}
                  </a>
                </div>
              </div>
            ) : null}

            {(settings?.FacebookHandle || settings?.TwitterHandle || settings?.InstagramHandle) ? (
              <>
                <div className={classes.socialLabel}>Síguenos</div>
                <div className={classes.socialRow}>
                  {settings.FacebookHandle ? (
                    <Tooltip title={t('follow_facebook')}>
                      <a
                        href={settings.FacebookHandle}
                        target="_blank"
                        rel="noreferrer"
                        className={classes.socialBtn}
                        aria-label="Facebook"
                      >
                        <i className={`${classes.socialIcon} fab fa-facebook`} />
                      </a>
                    </Tooltip>
                  ) : null}
                  {settings.TwitterHandle ? (
                    <Tooltip title={t('follow_twitter')}>
                      <a
                        href={settings.TwitterHandle}
                        target="_blank"
                        rel="noreferrer"
                        className={classes.socialBtn}
                        aria-label="Twitter"
                      >
                        <i className={`${classes.socialIcon} fab fa-twitter`} />
                      </a>
                    </Tooltip>
                  ) : null}
                  {settings.InstagramHandle ? (
                    <Tooltip title={t('follow_instagram')}>
                      <a
                        href={settings.InstagramHandle}
                        target="_blank"
                        rel="noreferrer"
                        className={classes.socialBtn}
                        aria-label="Instagram"
                      >
                        <i className={`${classes.socialIcon} fab fa-instagram`} />
                      </a>
                    </Tooltip>
                  ) : null}
                </div>
              </>
            ) : null}

            <div className={classes.footerTag}>
              <div className={classes.footerTagLine} />
              <span>EN TODO COLOMBIA</span>
            </div>
          </div>
        </div>
        <HomeFooter />
      </div>
    </div>
  );
}
